import React from 'react';

import { Cstable, Csrow, Cscell } from './cancellation-and-reschedule-penality.styles';

const TabelCell = ({ isHeading = false, bgColor = '', timeRangeOrCharges, subtitle = '' }) => {
  return (
    <Cscell hd={isHeading} bgColor={bgColor} today={bgColor?.length > 0}>
      <div dangerouslySetInnerHTML={{ __html: timeRangeOrCharges }}></div>
      {subtitle ? <span dangerouslySetInnerHTML={{ __html: subtitle }}></span> : null}
    </Cscell>
  );
};

const TabelRow = ({
  isHeading = false,
  bgColor = '',
  timeRange,
  charges,
  timeRangeSubTitle = '',
  chargesSubTitle = ''
}) => {
  return (
    <Csrow>
      <TabelCell
        isHeading={isHeading}
        timeRangeOrCharges={timeRange}
        bgColor={bgColor}
        subtitle={timeRangeSubTitle}
      />
      <TabelCell
        isHeading={isHeading}
        timeRangeOrCharges={charges}
        bgColor={bgColor}
        subtitle={chargesSubTitle}
      />
    </Csrow>
  );
};

const CancellationAndRescheduleTable = ({ tableHeading, penalties, voidCancellation }) => {
  return (
    <Cstable>
      {tableHeading && tableHeading.length && (
        <TabelRow
          isHeading={true}
          timeRange={tableHeading[0]?.title}
          timeRangeSubTitle={tableHeading[0]?.subtitle || ''}
          charges={tableHeading[1]?.title}
          chargesSubTitle={tableHeading[1]?.subtitle || ''}
        />
      )}
      {penalties &&
        penalties?.map((penalty, index) => (
          <TabelRow timeRange={penalty?.time_range} charges={penalty?.charges} key={index} />
        ))}
      {voidCancellation && (
        <TabelRow
          timeRange={voidCancellation?.void_info}
          charges={voidCancellation?.charges}
          bgColor={voidCancellation?.bg_color}
        />
      )}
    </Cstable>
  );
};

export default CancellationAndRescheduleTable;
